
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as demoQdjIkVGr_45FMqRR2TefXm0p7RetZLcSl_pww1Csl6f_0Meta } from "C:/Users/zlq13/Desktop/work/official-web/pages/demo.vue?macro=true";
import { default as aboutloPsRTR3JV5HJDHBfK4tIR_cj7yuGcEvILew3imSnncMeta } from "C:/Users/zlq13/Desktop/work/official-web/pages/about.vue?macro=true";
import { default as indexGPwRD7NVnCEHG4RX8SkRRlWdpJz2PL2fppz7R89mtxYMeta } from "C:/Users/zlq13/Desktop/work/official-web/pages/index.vue?macro=true";
import { default as loginL7JImHB5rb52DRv0v5hXqsgH_45qDhZ4D9WEWXxloyj1IMeta } from "C:/Users/zlq13/Desktop/work/official-web/pages/login.vue?macro=true";
import { default as contact_BQwNn_45AOp0XfaC2zHpAiPX1xTQHsnjxokhdP_45fUuO4Meta } from "C:/Users/zlq13/Desktop/work/official-web/pages/contact.vue?macro=true";
import { default as _91_46_46_46all_93aI4uonK2vIW35heT5HW_453fwanBwZctlPEvrbX_R91ykMeta } from "C:/Users/zlq13/Desktop/work/official-web/pages/[...all].vue?macro=true";
import { default as indext1LcFeB0GBPstDW_45cvWCNxYZExNht19gfMCjF7PLknEMeta } from "C:/Users/zlq13/Desktop/work/official-web/pages/home/index.vue?macro=true";
import { default as _91id_93HdF1H2_45GROm9zYFSZokHFk8_45ZWGRkcMuVGt5iQXAAFAMeta } from "C:/Users/zlq13/Desktop/work/official-web/pages/product/[id].vue?macro=true";
import { default as _91id_93ytEEb8WlTXYWN_45EtyjlW0HOUbe9ML6m_0NSu8Okqi2IMeta } from "C:/Users/zlq13/Desktop/work/official-web/pages/experience/[id].vue?macro=true";
import { default as industry_45solutionsbYFzKzV4Xy3JzYYPqmuVrNJST0UHxdlGkm7vTtgRzYcMeta } from "C:/Users/zlq13/Desktop/work/official-web/pages/industry-solutions.vue?macro=true";
import { default as powerb0xj1C9OEEsxCTxTIEayyJSpLuuKVvI_45oTcxgLr_45QwcMeta } from "C:/Users/zlq13/Desktop/work/official-web/pages/home/industry-solutions/power.vue?macro=true";
import { default as medicineF6MDnTLT9bSKBudoT5wFXr1ygBqlVFYYV5378At3AqEMeta } from "C:/Users/zlq13/Desktop/work/official-web/pages/home/industry-solutions/medicine.vue?macro=true";
import { default as educationkoZhox3B_UTUJsw_6quwdQ5qNCgy6ygOHh1TwwhSaIcMeta } from "C:/Users/zlq13/Desktop/work/official-web/pages/home/industry-solutions/education.vue?macro=true";
export default [
  {
    name: "demo",
    path: "/demo",
    component: () => import("C:/Users/zlq13/Desktop/work/official-web/pages/demo.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("C:/Users/zlq13/Desktop/work/official-web/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("C:/Users/zlq13/Desktop/work/official-web/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginL7JImHB5rb52DRv0v5hXqsgH_45qDhZ4D9WEWXxloyj1IMeta || {},
    component: () => import("C:/Users/zlq13/Desktop/work/official-web/pages/login.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: contact_BQwNn_45AOp0XfaC2zHpAiPX1xTQHsnjxokhdP_45fUuO4Meta || {},
    component: () => import("C:/Users/zlq13/Desktop/work/official-web/pages/contact.vue")
  },
  {
    name: "all",
    path: "/:all(.*)*",
    component: () => import("C:/Users/zlq13/Desktop/work/official-web/pages/[...all].vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("C:/Users/zlq13/Desktop/work/official-web/pages/home/index.vue")
  },
  {
    name: "product-id",
    path: "/product/:id()",
    component: () => import("C:/Users/zlq13/Desktop/work/official-web/pages/product/[id].vue")
  },
  {
    name: "experience-id",
    path: "/experience/:id()",
    component: () => import("C:/Users/zlq13/Desktop/work/official-web/pages/experience/[id].vue")
  },
  {
    name: "industry-solutions",
    path: "/industry-solutions",
    component: () => import("C:/Users/zlq13/Desktop/work/official-web/pages/industry-solutions.vue")
  },
  {
    name: "home-industry-solutions-power",
    path: "/home/industry-solutions/power",
    component: () => import("C:/Users/zlq13/Desktop/work/official-web/pages/home/industry-solutions/power.vue")
  },
  {
    name: "home-industry-solutions-medicine",
    path: "/home/industry-solutions/medicine",
    component: () => import("C:/Users/zlq13/Desktop/work/official-web/pages/home/industry-solutions/medicine.vue")
  },
  {
    name: "home-industry-solutions-education",
    path: "/home/industry-solutions/education",
    component: () => import("C:/Users/zlq13/Desktop/work/official-web/pages/home/industry-solutions/education.vue")
  }
]